import { atom } from "jotai";

export const isPlayingPodcastAtom = atom<boolean>(false);
